import { getMessaging, getToken, deleteToken } from 'firebase/messaging';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import app from '../firebase';
import { db } from '../firebase';

// Sem VAPID key explícita: o getToken() usa o certificado Web Push PADRÃO do FCM.
// A chave que estava fixa aqui não pertencia mais ao projeto (gerava 401
// "missing required authentication credential" / messaging/token-subscribe-failed
// no registro). O certificado padrão do FCM não depende de configuração manual
// no console e funciona com o envio via Admin SDK (sendBillReminders).

function detectPlatform() {
  const ua = navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
}

export function isPushSupported() {
  return (
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
  );
}

export async function requestPushPermission(uid) {
  if (!isPushSupported()) return { success: false, reason: 'not_supported' };

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { success: false, reason: 'denied' };

    const messaging = getMessaging(app);
    const token = await getToken(messaging);

    if (token) {
      await setDoc(doc(db, 'fcmTokens', uid), {
        token,
        platform: detectPlatform(),
        userAgent: navigator.userAgent,
        updatedAt: new Date().toISOString(),
      });
      return { success: true, token };
    }
    return { success: false, reason: 'no_token' };
  } catch (e) {
    console.warn('[FCM] Erro ao solicitar permissão:', e.message);
    return { success: false, reason: 'error', error: e.message };
  }
}

export async function disablePushNotifications(uid) {
  try {
    const messaging = getMessaging(app);
    await deleteToken(messaging).catch(() => {});
    await deleteDoc(doc(db, 'fcmTokens', uid));
  } catch (e) {
    console.warn('[FCM] Erro ao desativar push:', e.message);
  }
}

// Silently re-registers token on each session (tokens can rotate)
export async function refreshPushToken(uid) {
  if (!isPushSupported() || Notification.permission !== 'granted') return;
  try {
    const messaging = getMessaging(app);
    const token = await getToken(messaging);
    if (token) {
      await setDoc(doc(db, 'fcmTokens', uid), {
        token,
        platform: detectPlatform(),
        userAgent: navigator.userAgent,
        updatedAt: new Date().toISOString(),
      });
    }
  } catch (e) {
    console.warn('[FCM] Erro ao renovar token:', e.message);
  }
}
